import { Tooltip as BaseTooltip } from "@base-ui/react/tooltip";
import { clsx } from "clsx";
import type { JSX } from "react";

import * as styles from "./TooltipArrow.css";
import type { TooltipArrowProps } from "./Tooltip.types";

export function TooltipArrow({
  className,
  ...props
}: TooltipArrowProps): JSX.Element {
  return (
    <BaseTooltip.Arrow
      data-slot="tooltip-arrow"
      className={clsx(styles.arrow, className)}
      {...props}
    />
  );
}
